import { temperaturaQuente, temperaturaMorno, temperaturaFrio, isTemperaturaQuente, isTemperaturaMorno, isTemperaturaFrio } from '../../../common/temperatura';

export interface ClienteSituacaoInativoTemperatura {
    id: number;
    nome: string;
    color: string;
}

export const clienteSituacaoInativoTemperaturaQuente: ClienteSituacaoInativoTemperatura = {
    id: temperaturaQuente.id,
    nome: temperaturaQuente.nome,
    color: '#9b2822',
};

export const clienteSituacaoInativoTemperaturaMorno: ClienteSituacaoInativoTemperatura = {
    id: temperaturaMorno.id,
    nome: temperaturaMorno.nome,
    color: '#c8514a',
};

export const clienteSituacaoInativoTemperaturaFrio: ClienteSituacaoInativoTemperatura = {
    id: temperaturaFrio.id,
    nome: temperaturaFrio.nome,
    color: '#f0665f',
};

export const clienteSituacoesInativoTemperaturas: ClienteSituacaoInativoTemperatura[] = [
    clienteSituacaoInativoTemperaturaQuente,
    clienteSituacaoInativoTemperaturaMorno,
    clienteSituacaoInativoTemperaturaFrio
];

/** Verifica se a temperatura é um inativo com temperatura Quente */
export function isInativoTemperaturaQuente(temperatura: number): boolean {
    return isTemperaturaQuente(temperatura);
}

/** Verifica se a temperatura é um inativo com temperatura Morno */
export function isInativoTemperaturaMorno(temperatura: number): boolean {
    return isTemperaturaMorno(temperatura);
}

/** Verifica se a temperatura é um inativo com temperatura Frio */
export function isInativoTemperaturaFrio(temperatura: number): boolean {
    return isTemperaturaFrio(temperatura);
}
